import { formatUrl } from 'url-lib';
import moment from 'js-utils/moment';

const _getShareOptions = (url, id, shareOptions, affCode) => ({
    ...shareOptions,

    trackingCode: affCode,
    eventId: id,
    eventUrl: formatUrl(url, {
        'utm-medium': 'discovery',
        'utm-campaign': 'social',
        'utm-content': 'attendeeshare',
        'utm-source': 'collection',
        'utm-term': 'user-collection',
    }),
    'utm-options': {
        'utm-term': 'user-collection',
    },
});

export const getQualityShareOptions = ({ url, id }, shareOptions) =>
    _getShareOptions(url, id, shareOptions, 'editorial-collection');

export const getShareOptions = ({ url, id }, shareOptions) =>
    _getShareOptions(url, id, shareOptions, 'user-collection');

export const formatWeekForDisplay = (week) => {
    // We want weeks to start on Monday and end on Sunday
    // Todo: Add localization once we launch editorial collections in other countries
    const DATE_OFFSET = [1, 'day'];

    const firstDayOfWeek = moment(week)
        .startOf('week')
        .add(...DATE_OFFSET);

    const lastDayOfWeek = moment(week)
        .endOf('week')
        .add(...DATE_OFFSET);

    const isSameMonth = moment(firstDayOfWeek).isSame(lastDayOfWeek, 'month');

    const formattedFirstDayOfWeek = firstDayOfWeek.format('MMM D');
    const formattedLastDayOfWeek = isSameMonth
        ? lastDayOfWeek.format('D')
        : lastDayOfWeek.format('MMM D');

    return `${formattedFirstDayOfWeek} - ${formattedLastDayOfWeek}`;
};
